import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { resetPassword } from "../modules/actions";

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      resetPassword,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
